import { IndustryConfig } from '../../../types'

export const realEstateProfessionalsConfig: IndustryConfig = {
  id: 'real-estate-professionals',
  name: 'Real Estate Professionals',
  icon: '🏠',
  description: 'Real estate agents, brokers, and property management professionals focused on territory and market optimization',
  
  businessTypes: [
    {
      id: 'residential-agent',
      name: 'Residential Agent/Broker',
      description: 'Individual agents or brokers specializing in residential property sales'
    },
    {
      id: 'commercial-broker',
      name: 'Commercial Real Estate Broker',
      description: 'Brokers focused on commercial properties, office buildings, and investment properties'
    },
    {
      id: 'property-management',
      name: 'Property Management',
      description: 'Companies managing rental properties and real estate portfolios'
    },
    {
      id: 'real-estate-team',
      name: 'Real Estate Team/Brokerage',
      description: 'Real estate teams or small brokerages with multiple agents'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'commission-sales',
      name: 'Commission from Sales',
      description: 'Commission earned from property sales transactions',
      intelligenceValue: "We'll monitor local market conditions, average sale prices, inventory levels, and days on market to help optimize your commission earnings and identify high-opportunity territories."
    },
    {
      id: 'buyer-representation',
      name: 'Buyer Representation',
      description: 'Commission from representing buyers in property purchases',
      intelligenceValue: "We'll track buyer demand patterns, financing trends, and competitive buyer agent activity to help you position for more buyer representation opportunities."
    },
    {
      id: 'property-management-fees',
      name: 'Property Management Fees',
      description: 'Monthly management fees and leasing commissions from rental properties',
      intelligenceValue: "We'll monitor rental market trends, vacancy rates, and property management pricing to help optimize your fee structure and identify expansion opportunities."
    },
    {
      id: 'referral-income',
      name: 'Referral Income',
      description: 'Income from referrals to other agents or service providers',
      intelligenceValue: "We'll track referral network activity and identify high-value referral opportunities in adjacent markets or specialty services."
    }
  ],
  
  supplierCategories: [
    {
      id: 'marketing-advertising',
      name: 'Marketing & Advertising',
      suppliers: ['Zillow Premier Agent', 'Realtor.com', 'Facebook/Instagram Ads', 'Local publications', 'Direct mail services'],
      spendRanges: ['Under $1K', '$1K-$5K', '$5K-$15K', 'Over $15K']
    },
    {
      id: 'technology-tools',
      name: 'Technology & CRM Tools',
      suppliers: ['MLS subscriptions', 'CRM systems (Follow Up Boss, Chime, etc.)', 'Transaction management software', 'Lead generation platforms', 'Virtual tour services'],
      spendRanges: ['Under $500', '$500-$2K', '$2K-$5K', 'Over $5K']
    },
    {
      id: 'professional-services',
      name: 'Professional Services',
      suppliers: ['Photography/staging services', 'Legal services', 'Accounting/bookkeeping', 'Marketing consultants', 'Business coaching'],
      spendRanges: ['Under $2K', '$2K-$8K', '$8K-$20K', 'Over $20K']
    },
    {
      id: 'office-operations',
      name: 'Office & Operations',
      suppliers: ['Office rent/coworking space', 'Insurance (E&O, general liability)', 'Office supplies', 'Vehicle expenses', 'Communication tools'],
      spendRanges: ['Under $1.5K', '$1.5K-$4K', '$4K-$10K', 'Over $10K']
    }
  ],
  
  competitiveFactors: [
    'Local market knowledge',
    'Territory coverage',
    'Marketing presence',
    'Client testimonials/referrals',
    'Response time',
    'Technology adoption',
    'Professional network',
    'Pricing strategy',
    'Specialized expertise',
    'Years of experience'
  ]
}